/** The Active tab is the absent/`active` `list_version`; every other value is a sibling list. */
const isActiveMemberList = (listVersion?: string | null): boolean =>
    !listVersion || listVersion === 'active';

export default isActiveMemberList;
